// extracted by mini-css-extract-plugin
export var table = "_tw-0";